// src/utils/shareImage.js
// Unified image share utility used across all share call sites.
// Handles iOS Safari, iOS Chrome, Android, and desktop fallbacks consistently.

async function shareImage(blob, filename, shareText, title = 'The Magic Journey') {
  const file = new File([blob], filename, { type: 'image/jpeg' })
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent)
  const isIOSSafari = isIOS && /Safari/.test(navigator.userAgent) && !/CriOS/.test(navigator.userAgent)
  const isIOSChrome = isIOS && /CriOS/.test(navigator.userAgent)
  const canShareFiles = typeof navigator.canShare === 'function'

  // iOS Chrome — can't share files; open blob URL so user can long-press → Save/Share
  if (isIOSChrome) {
    const blobUrl = URL.createObjectURL(blob)
    window.open(blobUrl)
    return
  }

  // iOS Safari or Android/desktop with file share support
  if (canShareFiles && navigator.canShare({ files: [file] })) {
    try {
      await navigator.share({ files: [file], title, text: shareText })
      return
    } catch (e) {
      if (e.name === 'AbortError') return // user cancelled
    }
  }

  // Text-only fallback
  if (navigator.share) {
    try { await navigator.share({ title, text: shareText }) } catch (e) {}
    return
  }

  // Desktop fallback — download the file
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}

export default shareImage
